import { render, staticRenderFns } from "./law-dialog.vue?vue&type=template&id=6d33ef43&scoped=true"
import script from "./law-dialog.vue?vue&type=script&lang=js"
export * from "./law-dialog.vue?vue&type=script&lang=js"
import style0 from "./law-dialog.vue?vue&type=style&index=0&id=6d33ef43&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d33ef43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d33ef43')) {
      api.createRecord('6d33ef43', component.options)
    } else {
      api.reload('6d33ef43', component.options)
    }
    module.hot.accept("./law-dialog.vue?vue&type=template&id=6d33ef43&scoped=true", function () {
      api.rerender('6d33ef43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taxLaw/home/recommend-law/law-dialog.vue"
export default component.exports